import { Layout } from "antd";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import SessionTimeoutModal from "../components/SessionTimeoutModal";
import ErrorComponent from "../pages/Error-page/ErrorComponent";
import CustomHeader from "../components/CustomHeader"
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import store from '../store/configureStore';
import { toggleComponentErrorPage } from '../reducers/componentErrorSlice';
import "./layout.scss"
const { Sider, Content, Header } = Layout;

const MainLayout = () => {
    const sessionDialog = useSelector(state => state.sessionDialog);
    const showError = useSelector(state => state.componentError).show;
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    useEffect(() => {
        if (location.pathname == "/ai-mbr") {
            setCollapsed(true);
        }
    }, [location])

    useEffect(() => {
        if (showError) {
            store.dispatch(toggleComponentErrorPage({ show: false }));
        }
      }, [location.pathname]);
    return (
        <Layout style={{ height: '100vh' }}>
            <Header className="main-header-container">
                <CustomHeader collapsed={collapsed} setCollapsed={setCollapsed} />
            </Header>
            <Layout className="main-layout-container">
                <Sider
                    theme="light"
                    style={{ background: "transparent" }}
                    breakpoint="lg"
                    collapsedWidth="0"
                    collapsible
                    collapsed={collapsed}
                    trigger={null}
                    onCollapse={value => setCollapsed(value)}
                    onBreakpoint={(broken) => {
                        setCollapsed(broken);
                    }}
                    width="240"
                    className="sidebarMain"
                >
                    <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
                </Sider>
                <Layout style={{ background: "#EDEFF7" }}>
                    <Content
                        className="main-content"
                    >
                        {showError ? (
                            <ErrorComponent />
                        ) : (
                                <>
                                    <Outlet />
                                    <SessionTimeoutModal
                                        visible={sessionDialog.show}
                                        handleOk={() => { }}
                                    />
                                </>
                            )}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default MainLayout;

